import { render, staticRenderFns } from "./GrcCombo.vue?vue&type=template&id=3dc36ec6&scoped=true&"
import script from "./GrcCombo.vue?vue&type=script&lang=js&"
export * from "./GrcCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc36ec6",
  null
  
)

export default component.exports